import React, { Fragment, useEffect, useState, memo, useCallback, useMemo } from 'react';
import OfferList from '../../../components/offer/offerList';
import Pagination from '../../../components/Form/Pagination';
import API from '../../../api/axios/API';
import { EuiLoadingContent, EuiFlexGroup, EuiFlexItem, EuiComboBox, EuiSpacer } from '@elastic/eui';
import ErrorMessage from '../../../components/UIComponent/ErrorMessage';
import { useSelector } from 'react-redux';

const OfferTable = ({ selectedOutlet = [], setSelectedOutlet }) => {
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const refetchOffers = useSelector((state) => state.offersReducer.refetchOffers);

    const [offers, setOffers] = useState({});
    const outletList = useSelector((state) => state.outlet.outletList);

    const fetchOffers = useCallback(async () => {
        setLoading(true);
        try {
            let url = `restaurants/:restaurantId/offers?page=${pagination.pageIndex + 1}&per_page=${pagination.pageSize}`;

            if (selectedOutlet.length > 0) {
                const outletParams = selectedOutlet
                    .map((outlet, index) => `outlet_ids[${index}]=${outlet.value}`)
                    .join('&');
                url += `&${outletParams}`;
            }

            const offers = await API.get(url);
            setOffers(offers);
            setLoading(false);
        } catch (e) {
            setError(e);
            setLoading(false);
        }
    }, [pagination.pageIndex, pagination.pageSize, selectedOutlet]);

    const handlePageChange = useCallback(
        (page) => {
            setPagination({
                ...pagination,
                pageIndex: page,
            });
        },
        [pagination]
    );

    useEffect(() => {
        fetchOffers();
    }, [refetchOffers, pagination.pageIndex, fetchOffers]);

    const outletOptions = useMemo(() => {
        const options = [];
        if (outletList && outletList.length) {
            outletList.forEach((outlet) => {
                options.push({
                    value: outlet.value || outlet.outlet_id || outlet.id,
                    label:
                        outlet.inputDisplay ||
                        outlet.label ||
                        outlet?.translations?.name?.[1] ||
                        outlet?.translations?.name?.[Object.keys(outlet?.translations?.name || {})[0]] ||
                        'Unnamed Outlet',
                });
            });
        }
        return options;
    }, [outletList]);

    if (loading) return <EuiLoadingContent lines={4} />;
    if (error) return <ErrorMessage />;

    return (
        <Fragment>
            <EuiFlexGroup alignItems='center' gutterSize='m'>
                <EuiFlexItem grow={false} style={{ minWidth: 350 }}>
                    <EuiComboBox
                        placeholder='Select outlets'
                        options={outletOptions}
                        selectedOptions={selectedOutlet}
                        onChange={(selectedOptions) => setSelectedOutlet(selectedOptions)}
                        isClearable={true}
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
            <EuiSpacer size='m' />
            <OfferList offerList={offers} fetchOffers={fetchOffers} />
            {offers?.offers?.total > offers?.offers?.per_page && (
                <Pagination
                    totalRecord={offers.offers.total}
                    pageSize={offers.offers.per_page}
                    activePage={offers.offers.current_page - 1}
                    handlePageChange={handlePageChange}
                />
            )}
        </Fragment>
    );
};

export default memo(OfferTable);
